<template>
  <div class="background">
    <div v-if="tableData.length > 0" style="margin-bottom: 10px;color: #f00;">{{ tableData[0].msg }}</div>
    <div style="padding-bottom: 20px;display: flex">
      <div class="colorCon">
        <span
          class="colorClass colorClass1"
          style="background:#64B1FF;"
        />
        <!--重算后价格变低-->
        <span class="colorTitle">{{
          $t('receivablePayable.ThePriceBecomesLowerAfterRecalculation')
        }}（{{ tableData[0] && tableData[0].resultTypeCountMap && tableData[0].resultTypeCountMap[3] || 0 }}）</span>
      </div>
      <div class="colorCon">
        <span
          class="colorClass colorClass2"
          style="background:#FF3E3E;"
        />
        <!--重算后价格变高-->
        <span class="colorTitle">{{
          $t('receivablePayable.ThePriceBecomesHigherAfterRecalculation')
        }}（{{ tableData[0] && tableData[0].resultTypeCountMap && tableData[0].resultTypeCountMap[2] || 0 }}）</span>
      </div>
      <div class="colorCon">
        <span
          class="colorClass colorClass3"
          style="background:#999999;"
        />
        <!--重算后价格为0-->
        <span class="colorTitle">{{
          $t('receivablePayable.ThePriceAfterRecalculationIs0')
        }}（{{ tableData[0] && tableData[0].resultTypeCountMap && tableData[0].resultTypeCountMap[1] || 0 }}）</span>
      </div>
      <div class="colorCon">
        <span
          class="colorClass colorClass4"
          style="background:#FFFFFF;border: 1px solid #999999;"
        />
        <!--重算后价格不变-->
        <span class="colorTitle">{{
          $t('receivablePayable.ThePriceRemainsUnchangedAfterRecalculation')
        }}（{{ tableData[0] && tableData[0].resultTypeCountMap && tableData[0].resultTypeCountMap[0] || 0 }}）</span>
      </div>
    </div>
    <el-table
      :cell-class-name="myClass"
      :data="tableData"
      border
      height="400"
    >
      <el-table-column
        :label="$t('operationCenter.ind')"
        align="center"
        width="60px"
      >
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumns"
        :key="index"
        :align="item.fixed"
        :label="item.label"
        :prop="item.prop"
        :show-overflow-tooltip="true"
        :min-width="item.width"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页工具 -->
    <div class="pagination">
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0"
        @current-change="getCurrentTablePageData"
        @size-change="getSizeTablePageData"
      />
    </div>
    <div style="text-align: right;">
      <!--确认替换价格-->
      <el-button
        size="small"
        type="primary"
        @click="confirmReplacement(true)"
      >{{ $t('receivablePayable.ConfirmTheReplacementPrice') }}
      </el-button>
      <!--取消重算-->
      <el-button
        size="small"
        @click="confirmReplacement(false)"
      >{{ $t('receivablePayable.CancelTheRecalculation') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  apiPayableSiteExpenseGetReCalculatePriceResult,
  apiPayableSiteExpenseImportReCalculatePriceConfirm,
  apiPayableSiteExpenseImportReCalculatePriceTable,
  apiPayableSiteExpensePriceResult,
  apiPayableSiteExpenseReCalculatePrice,
  apiPayableTransportExpenseGetReCalculatePriceResult,
  apiPayableTransportExpenseReCalculatePrice,
  apiTransportNewConfirmReCalculatePriceResult
} from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';

export default {
  name: '',
  props: {
    // 搜索条件
    getParam: {
      type: Object,
      required: true
    },

    // 勾选
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    importList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    importData: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 重算价格数据类型
    // 0：查询结果计算；1：勾选数据计算 2：导入数据计算 3：导入重量计算
    calculationType: {
      type: Number,
      default: 0
    },

    // 重算参数
    collectingDispatch: {
      type: Object,
      default: () => {
        return {};
      }
    },
    postData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10
      },
      total: 0,
      currentColumns: [
        // 业务单号
        {
          prop: 'waybillNumber',
          label: this.$i18n.t('receivablePayable.TicketNumber'),
          width: 200,
          fixed: 'left',
          highlight: false,
          disabled: true
        },
        // 客户单号
        {
          prop: 'customerNumber',
          label: this.$i18n.t('receivablePayable.CustomerTrackingNumber'),
          width: 200,
          fixed: 'left',
          highlight: false,
          disabled: true
        },
        // 网点
        {
          prop: 'siteName',
          label: this.$i18n.t('basicData.Outlets'),
          width: 160,
          fixed: 'left',
          highlight: false,
          disabled: true
        },
        // 客户
        {
          prop: 'customerAlias',
          label: this.$i18n.t('receivablePayable.customer'),
          width: 120,
          fixed: 'left',
          highlight: true,
          disabled: true
        },
        // 费用类型
        {
          prop: 'feeName',
          label: this.$i18n.t('basicData.ExpenseType'),
          width: 120,
          fixed: 'left',
          highlight: true,
          disabled: true
        },
        // 价格（重算前）
        {
          prop: 'oldFee',
          label: this.$i18n.t('receivablePayable.PriceBeforeRecalculation'),
          width: 160,
          fixed: 'left',
          highlight: false,
          disabled: true
        },
        // 价格（重算后）
        {
          prop: 'newFee',
          label: this.$i18n.t('receivablePayable.PriceAfterRecalculation'),
          width: 160,
          fixed: 'left',
          highlight: false,
          disabled: true
        },
        // 计费重量（重算前）
        {
          prop: 'oldChargeWeight',
          label: this.$i18n.t('receivablePayable.BillableWeightBeforeRecalculation') + '(KG)',
          width: 160,
          fixed: 'left',
          highlight: false,
          disabled: true
        },
        // 计费重量(重算后)
        {
          prop: 'newChargeWeight',
          label: this.$i18n.t('receivablePayable.BillableWeightRecalculated') + '(KG)',
          width: 160,
          fixed: 'left',
          highlight: false,
          disabled: true
        }
      ],
      isRecalculate: false
    };
  },
  computed: {
    tableColumns() {
      const columns = cloneDeep(this.currentColumns);
      if (this.getParam.payableType === 5) {
        // 运输单号
        const obj = {
          prop: 'transportNumber',
          label: this.$t('basicData.TransportOrderNumber'),
          width: 200,
          fixed: 'left',
          highlight: false,
          disabled: true
        };
        const list = columns.slice(4);
        list.unshift(obj);
        return list;
      }
      return columns;
    }
  },
  methods: {
    // 确定替换
    confirmReplacement(type) {
      const params = {
        isReplace: type,
        payableType: this.getParam.payableType
      };
      const API = this.getParam.payableType === 5
        ? this.isRecalculate ? apiPayableSiteExpenseImportReCalculatePriceConfirm : apiTransportNewConfirmReCalculatePriceResult
        : apiPayableSiteExpensePriceResult;
      API(params).then(res => {
        if (res.code === 200) {
          const msg = type ? this.$t('receivablePayable.ReplacementSuccessful') : this.$t('orderCenterCont.CancellationSuccessful'); // '替换成功' : '取消成功'
          this.$message.success(msg);
          this.$emit('changePage', true);
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 背景色
    myClass({ row, column, rowIndex, columnIndex }) {
      if (row.resultType === 0) {
        return 'unchanged';
      } else if (row.resultType === 1) {
        return 'zero';
      } else if (row.resultType === 2) {
        return 'getHigher';
      } else if (row.resultType === 3) {
        return 'lower';
      }
    },
    // 获取重算数据
    getRecalculateTable() {
      // 干支线重算
      console.log(this.postData, 'params');
      const { pageSize, pageNumber, params } = this.postData;
      if (this.getParam.payableType === 5) {
        const data = {
          pageNumber: pageNumber,
          pageSize: pageSize
        };
        this.isRecalculate = !params;
        if (params) {
          const {
            transportNumberList, providerId, timeField, startTime, endTime,
            isAccept, isGenBill, vehicleNumber, driverId, vehicleType, routeType, lineId
          } = params;
          data.params = {
            transportNumberList, providerId, timeField, startTime, endTime,
            isAccept, isGenBill, vehicleNumber, vehicleType, driverId, routeType, lineId
          };
        }
        console.log(data, '运输重算params');
        // 获取重算数据 params参数
        const API = !params ? apiPayableSiteExpenseImportReCalculatePriceTable : apiPayableTransportExpenseReCalculatePrice;
        API(data).then(res => {
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          } else {
            this.$emit('changePage', false);
          }
        }).catch(() => {
          this.$emit('changePage', false);
        });
      } else {
        const params = cloneDeep(this.getParam); // 查询条件
        const objDate = {
          pageNumber: this.queryForm.pageNumber,
          pageSize: this.queryForm.pageSize,
          params
        };

        /**
         * 安俊及第三方揽收
         */
        if (params.businessType === 2) {
          objDate.orderDirection = 'DESC';
          objDate.orderProperty = '';
          objDate.params = { ...this.collectingDispatch, ...this.postData, collectType: params.collectType };
        }

        /**
         * AJD派送单
         */
        if (params.businessType === 3 && params.payableType === 3) {
          // console.log(this.postData, '====this.postData---AJD', objDate);
          objDate.params = this.postData.params;
        }

        /**
         * DSP派送单/邮局
         */
        console.log(this.importData, '------------', this.importList);
        if (params.businessType === 3 && [4, 6].includes(params.payableType)) {
          const obj = cloneDeep(this.collectingDispatch);
          if (this.importData.length > 0 || this.importList.length > 0) {
            // 2.是否为导入
            if (this.importData.length > 0) {
              obj.reCalculatePriceSource = 2;
              obj.importDataList = this.importData;
            }
            // 3.是否为重量导入
            if (this.importList.length > 0) {
              obj.reCalculatePriceSource = 3;
              obj.importDataList = this.importList;
            }
          } else {
            // 1.是否勾选
            if (this.selectData.length > 0) {
              obj.ids = this.selectData.map((item) => item.id);
              obj.reCalculatePriceSource = 1;
            }
          }
          objDate.params = { ...params, ...obj };
        }
        // return;

        apiPayableSiteExpenseReCalculatePrice(objDate).then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          }
        }).catch(() => {
          this.$emit('changePage', false);
        });
      }
    },
    // 重算分页查询
    getTablePageData() {
      const fnc = this.getParam.payableType === 5
        ? this.isRecalculate
          ? apiPayableSiteExpenseImportReCalculatePriceTable
          : apiPayableTransportExpenseGetReCalculatePriceResult
        : apiPayableSiteExpenseGetReCalculatePriceResult;
      fnc({
        list: this.queryForm,
        payableType: this.getParam.payableType
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
        }
      });
    },
    // 翻页
    getCurrentTablePageData(val) {
      this.queryForm.pageNumber = val;
      this.getTablePageData();
    },
    // 每页显示数量变化
    getSizeTablePageData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getTablePageData();
    }
  }
};
</script>

<style>
.background .el-table tbody td {
  color: #000;
}

.background .el-table tbody tr:hover td {
  background-color: transparent !important;
}

.background .el-table tbody td.unchanged {
  background-color: #fff !important;
}

.background .el-table tbody td.zero {
  background-color: #999999 !important;
}

.background .el-table tbody td.getHigher {
  background-color: #ff3e3e !important;
}

.background .el-table tbody td.lower {
  background-color: #64b1ff !important;
}

.colorCon {
  margin-right: 10px;
  height: 20px;
  display: flex;
  align-items: center;
}

.colorClass {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  /* float: left; */
}

.colorTitle {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  /* float: left; */
}
</style>
